
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 7.25v6.015h-6.016l2.735-2.734c-.99-1.042-2.188-1.563-3.594-1.563-1.433 0-2.649.502-3.652 1.504-1.003 1.003-1.504 2.22-1.504 3.653 0 1.432.501 2.65 1.504 3.652 1.003 1.003 2.219 1.504 3.652 1.504 1.094 0 2.077-.3 2.949-.898A4.874 4.874 0 0018.93 16h1.797a6.803 6.803 0 01-2.442 3.593c-1.211.938-2.598 1.407-4.16 1.407-1.901 0-3.522-.67-4.863-2.012-1.342-1.34-2.012-2.962-2.012-4.863 0-1.902.67-3.522 2.012-4.864 1.341-1.34 2.962-2.01 4.863-2.01 1.875 0 3.489.676 4.844 2.03L21 7.251zM4.375 0v1.25h6.25V0H12.5v1.25h.938c.417 0 .78.156 1.094.469A1.5 1.5 0 0115 2.813v3.594a7.977 7.977 0 00-1.562-.001v-1.25H1.563v8.282h4.785c-.028.27-.043.545-.043.822 0 .25.015.496.037.74h-4.78c-.416 0-.78-.156-1.093-.47-.312-.311-.47-.675-.47-1.092V2.813a1.5 1.5 0 01.47-1.094c.313-.313.677-.47 1.094-.47H2.5V0h1.875z","fill":"#4788C6","fill-rule":"evenodd"}})])
          )
        }
      }
    